import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import registerServiceWorker from './registerServiceWorker'
import 'react-mdl/extra/material.css'
import 'react-mdl/extra/material.js'
import { BrowserRouter } from 'react-router-dom'

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root'))
registerServiceWorker()

/* LoginPage */

/**
 * Function that gets the data of the profile in case
 * thar it has already saved in localstorage. Only the
 * UI will be update in case that all data is available
 *
 * A not existing key in localstorage return null
 *
 */
/* function getLocalProfile(callback){

    var profileName        = localStorage.getItem("PROFILE_NAME");
    var profileReAuthEmail = localStorage.getItem("PROFILE_REAUTH_EMAIL");

    if(profileName !== null
            && profileReAuthEmail !== null)
           {
        callback(profileName, profileReAuthEmail);
    }
} */

/**
 * Main function that load the profile if exists
 * in localstorage
 */
/* function loadProfile() {
    if(!supportsHTML5Storage()) { return false; }
    // we have to provide to the callback the basic
    // information to set the profile
    getLocalProfile(function(profileName, profileReAuthEmail) {
        //changes in the UI

        ("#profile-name").html(profileName);
        ("#reauth-email").html(profileReAuthEmail);
        ("#inputEmail").hide();
        ("#remember").hide();
    });
} */

/**
 * function that checks if the browser supports HTML5
 * local storage
 *
 * @returns {boolean}
 */
/* function supportsHTML5Storage() {
    try {
        return 'localStorage' in window && window['localStorage'] !== null;
    } catch (e) {
        return false;
    }
} */

/**
 * Test data. This data will be safe by the web app
 * in the first successful login of a auth user.
 * To Test the scripts, delete the localstorage data
 * and comment this call.
 *
 * @returns {boolean}
 */
/* function testLocalStorageData() {
    if(!supportsHTML5Storage()) { return false; }

    localStorage.setItem("PROFILE_NAME", "César Izquierdo Tello");
    localStorage.setItem("PROFILE_REAUTH_EMAIL", "oneaccount@gmail.com");
} */



// WEBPACK FOOTER //
// ./src/index.js